<template>
    <div class="ui-card">
        <div class="ui-card-body">
            <slot/>
        </div>
        <div class="ui-card-footer" v-if="$slots.footer">
            <slot name="footer"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UiCard"
    };
</script>

<style lang="scss" scoped>
    .ui-card {
        background-color: white;
        border-radius: 0.5rem;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .ui-card-body {
            padding: 1.5rem;

            @media (max-width: 768px) {
                padding: 1rem;
            }
        }

        // Same cool grey as the row-level CTA strip (assets/scss/_cta.scss)
        // so every "action area" in the app reads the same
        .ui-card-footer {
            padding: 1rem 1.5rem;
            border-top: 1px solid #e6eaef;
            background-color: #f4f6f9;
            border-bottom-left-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
        }
    }
</style>
